/*! @azure/msal-react v2.0.13 2024-03-22 */
'use strict';
import { useState, useEffect } from 'react';
import { useMsal } from './useMsal.js';
import { InteractionStatus } from '@azure/msal-browser';
import { getAccountByIdentifiers } from '../utils/utilities.js';

/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */
function isAuthenticated(allAccounts, matchAccount) {
    if (matchAccount &&
        (matchAccount.username ||
            matchAccount.homeAccountId ||
            matchAccount.localAccountId)) {
        return !!getAccountByIdentifiers(allAccounts, matchAccount);
    }
    return allAccounts.length > 0;
}
/**
 * Returns whether or not a user is currently signed-in. Optionally provide 1 or more accountIdentifiers to determine if a specific user is signed-in
 * @param matchAccount
 */
function useIsAuthenticated(matchAccount) {
    const { accounts: allAccounts, inProgress } = useMsal();
    const [hasAuthenticated, setHasAuthenticated] = useState(() => {
        if (inProgress === InteractionStatus.Startup) {
            return false;
        }
        return isAuthenticated(allAccounts, matchAccount);
    });
    useEffect(() => {
        setHasAuthenticated(isAuthenticated(allAccounts, matchAccount));
    }, [allAccounts, matchAccount]);
    return hasAuthenticated;
}

export { useIsAuthenticated };
//# sourceMappingURL=useIsAuthenticated.js.map
